import React from 'react';
import { useEffect, useRef, useState } from 'react';
import AllowcateWorkerModal from '@/components/AllowcateWorkerModal';
// import { removePartner } from '@/services/customerServices';
import styles from './index.module.less';

const typeMap = {
  ['ASSIGN_SALES']: '营销员',
  ['ASSIGN_DESIGNER_MNR']: '设计部经理',
  ['ASSIGN_DESIGNER']: '设计师',
  ['ASSIGN_SEAT_MAN']: '坐席',
  ['ASSIGN_CALL_MNR']: '呼叫经理',
  ['ASSIGN_SALES_MNR']: '营销部经理',
  ['ASSIGN_ELECTRIC']: '电商专员',
  ['ASSIGN_ELECTRIC_MNR']: '电商经理',
  ['ASSIGN_ASSIST']: '分公司总助',
  ['ASSIGN_DELIVERY_ASSISTANT']: '分公司交付助理',
  ['ASSIGN_DEEPENING_DESIGNER']: '深化设计师',
  ['ASSIGN_SOFT_DESIGN_MNR']: '软装设计部经理',
  ['ASSIGN_SOFT_DESIGN']: '软装设计师',
  ['ASSIGN_TAILOR_MADE_DESIGN_MNR']: '定制设计部经理',
  ['ASSIGN_TAILOR_MADE_DESIGN']: '定制设计师',
  ['ASSIGN_ACHIEVEMENT_DESIGN']: '业绩设计师',
  ['ASSIGN_CHU_GUI_WARDROBE_DESIGN']: '橱柜设计师',
  ['ASSIGN_DELIVERY_ACHIEVEMENT']: '交付业绩人员',
  ['ASSIGN_DELIVERY_ACHIEVEMENT_MNR']: '交付业绩部门经理',
  ['ASSIGN_MEMBER_CALL_CENTER']: '会员客服',
}

export default function ServiorInfo ({
  hidden = false,
  basicInfo = [],
  editId = '',
  tab = '',
  orgId = '',
  buttonKeyList = [],
  reload = () => {},
})  {
  const [openAllowcateModal, setOpenAllowcateModal] = useState(false);
  const [chooseButtonKey, setChooseButtonKey] = useState('');
  const [serviceDataMap, setServiceDataMap] = useState({})
  const [trackPlanNodeId, setTrackPlanNodeId] = useState('');
  const [personKeyList, setPersonKeyList] = useState([]);

  const handleopenAllowcateModal = (key: string, id: string) => {
    setChooseButtonKey(key);
    setTrackPlanNodeId(id);
    setOpenAllowcateModal(true);
  }

  /*const handleRemove = async (id) => {
    const res: any = await removePartner({ trackPlanRelativesId: [id] });
    if (res.errorCode === 0 && res.status) {
      message.success(`移除协作人成功`);
      reload();
    } else {
      message.error(`移除协作人失败`);
    }
  }*/

  useEffect(() => {
    if (basicInfo) {

      const map: any = {};
      (basicInfo as any).forEach(info => {
        if (map[info?.buttonKey]?.length) {
          map[info?.buttonKey].push(info)
        } else {
          map[info?.buttonKey] = [{...info}]
        }
      })
      const keyList = Object.keys(map);

      // 排序
      const orderKeyList = [
        'ASSIGN_SEAT_MAN',
        'ASSIGN_CALL_MNR',
        'ASSIGN_ELECTRIC',
        'ASSIGN_ELECTRIC_MNR',
        'ASSIGN_DELIVERY_ASSISTANT',
        'ASSIGN_ASSIST',
        'ASSIGN_SALES',
        'ASSIGN_SALES_MNR',
        'ASSIGN_DESIGNER_MNR',
        'ASSIGN_DESIGNER',
        'ASSIGN_SOFT_DESIGN',
        'ASSIGN_SOFT_DESIGN_MNR',
        'ASSIGN_TAILOR_MADE_DESIGN',
        'ASSIGN_TAILOR_MADE_DESIGN_MNR',
        'ASSIGN_ACHIEVEMENT_DESIGN',
        'ASSIGN_CHU_GUI_WARDROBE_DESIGN',
        'ASSIGN_DEEPENING_DESIGNER',
        'ASSIGN_DELIVERY_ACHIEVEMENT',
        'ASSIGN_DELIVERY_ACHIEVEMENT_MNR',
        'ASSIGN_MEMBER_CALL_CENTER'
      ]
      const newKeyList: any = orderKeyList.filter(item => keyList.includes(item));
      setPersonKeyList(newKeyList);
      setServiceDataMap(map);
    }

  }, [basicInfo]);

  return (
    <>
      <div className={styles.serviceBasicInfoBox}>
        {
          personKeyList?.length ? personKeyList?.map((key: string) => (
            <div className={styles.serviorBox}>
              <div style={{ fontWeight: 500, marginBottom: '5px' }}>{ typeMap[key] }</div>
              <div
                style={{ marginBottom: '5px', fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}
              >
                {
                  serviceDataMap?.[key]?.map((sale: any) => (
                    <>
                      <span style={{ color: 'rgba(87, 88, 89, 1)' }}>
                        {sale?.name}（{sale?.deptName}）
                      </span>
                      { buttonKeyList?.includes(key) && !hidden && <span onClick={() => handleopenAllowcateModal(key, sale?.trackPlanNodeId)} style={{ marginLeft: 15, color: 'rgba(0, 100, 255, 1)', cursor: 'pointer' }}>变更</span>}
                    </>
                  ))
                }
              </div>
            </div>
          )) : null
        }
      </div>
      { openAllowcateModal && <AllowcateWorkerModal orgId={orgId} tab={tab} trackPlanNodeId={trackPlanNodeId} changeFlag={true} buttonKey={chooseButtonKey} reload={reload} editId={editId} open={openAllowcateModal} onClose={() => setOpenAllowcateModal(false)} />}
    </>
  )
}